<template>
  <!--  重绑手机-->
  <div class="re-bind-phone view-box">
    <navBan title="重绑手机"></navBan>

    <template v-if="bindPhoneStep===1">
      <p class="tip">输入新手机号，点击下一步，将会发送一条验证短信到手机</p>
      <div class="input-box" style="margin-top: 32px">
        <img class="icon" src="../../assets/images/Phone.svg" alt="">
        <input v-model="phone" placeholder="手机号" type="text">
      </div>
      <button
        @click="getCode(2)"
        class="button"
        :class="{ 'button-disabled': phone==='' }"
        :disabled="phone===''"
      >发送验证码</button>
    </template>

    <template v-if="bindPhoneStep === 2">
      <p class="tip">已向{{phone}} 发送了一条验证短信</p>
      <div class="check-code">
        <span class="text">请输入6位数字验证码</span>
        <span v-if="second" class="text">{{second + 'S'}}</span>
        <span v-else class="text second" @click="getCode(2)">重新发送</span>
      </div>

      <div class="btn-group">
        <template v-for="(item, index) of phoneCode.list" :key="index">
          <input
            class="m-input phone-code-input"
            @input="val => phoneCodeChange(val, item, index)"
            v-model="item.value"
            type="text" inputmode="numeric" autocomplete="one-time-code"
          >
        </template>
      </div>

      <button
        @click="reBindPhone('mobile')"
        class="button"
        style="margin-top: 16px"
        :class="{ 'button-disabled': phoneCode.list.some(item => item.value === '') }"
        :disabled="phoneCode.list.some(item => item.value === '')"
      >完成绑定</button>
    </template>
  </div>
</template>

<script setup>
import navBan from '@/components/navBan';
import { phoneCode, phoneCodeChange, second } from '@/utils/setup/captchaInput';
import { bindPhoneStep, phone, getCode, reBindPhone, userMobile } from '@/utils/setup/bindMobile';
import { onMounted, onUnmounted } from 'vue';

let PlatForm = sessionStorage.getItem('PlatFormType');
let appType = sessionStorage.getItem('appType');

function agentFallback (e) {
  setTimeout(() => {
    window.history.go(-2);
  }, 200);
};

if (PlatForm == 2 || (PlatForm == 1 && appType == 1)) {
  window.addEventListener(
    'popstate',
    agentFallback,
    true
  );
}

onUnmounted(() => {
  if (PlatForm == 2 || (PlatForm == 1 && appType == 1)) {
    setTimeout(() => {
      window.removeEventListener('popstate', agentFallback, true);
    }, 1000);
  }
});

</script>

<style lang="scss" scoped>
.view-box{
  padding-top:1px;
}
.re-bind-phone {
  .tip {
    margin-top: 32px;
    color: rgba(134, 143, 156, 1);
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 18px;
  }
}
</style>
